import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import LoginComponent from './LoginComponent';
const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading, hasPersistentAuth } = useAuth();
    // Debug protected route state
    useEffect(() => {
        console.log('🔒 Protected Route Debug:', {
            isAuthenticated,
            isLoading,
            hasPersistentAuth,
            shouldShowLogin: !isAuthenticated && !isLoading,
        });
    }, [isAuthenticated, isLoading, hasPersistentAuth]);
    if (isLoading) {
        return (_jsxs("div", { className: "loading-container", children: [_jsx("div", { children: "Loading authentication..." }), _jsx("div", { style: { fontSize: '0.8rem', color: '#666', marginTop: '0.5rem' }, children: hasPersistentAuth ? 'Restoring your session...' : 'Checking authentication...' })] }));
    }
    if (!isAuthenticated) {
        console.log('🔒 User not authenticated, showing login component');
        return _jsx(LoginComponent, {});
    }
    console.log('🔒 User authenticated, showing protected content');
    return _jsx(_Fragment, { children: children });
};
export default ProtectedRoute;
